import { getEnv } from '@hub/helpers/getters.store';
import ContestAccountService from '@hub/services/entities/contest-account-service';

export class ContestAccountStore {
  contestAccountService: ContestAccountService;

  constructor() {
    const {
      apiFactory: { contestAccountService },
    } = getEnv();

    this.contestAccountService = contestAccountService;
  }

  getContestAccount(tsAccountId: string) {
    return this.contestAccountService.getContestAccount(tsAccountId);
  }

  getAccountArchive(tsAccountId: string) {
    return this.contestAccountService.getAccountArchive(tsAccountId);
  }

  getBalanceChart(tsAccountId: string) {
    return this.contestAccountService.getBalanceChart(tsAccountId);
  }

  getBalance(tsAccountId: string) {
    const {
      apiFactory: { contestAccountService },
    } = getEnv();

    return contestAccountService.getBalance(tsAccountId);
  }

  getDailyPerformance(tsAccountId: string) {
    return this.contestAccountService.getDailyPerformance(tsAccountId);
  }

  getStats(tsAccountId: string) {
    return this.contestAccountService.getStats(tsAccountId);
  }

  getCredentials(tsAccountId: string) {
    return this.contestAccountService.getCredentials(tsAccountId);
  }
}
